// based on rc-notification 4.5.7
import Notification from './Notification';
export default Notification;